<template>
	<div class="circle-remind">
		<div class="circle-remind-wrap">
			<div class="circle-remind-header">
				<div class="circle-remind-title">提醒谁看</div>
				<div class="circle-remind-h-opts">
					<span @click="close">关闭</span>
				</div>
			</div>
			<div class="circle-remind-box">
				<form class="layui-form" action="">
				 <div class="layui-form-item">
				   <label class="layui-form-label"><i class="layui-icon">&#xe770;</i>粉丝选择</label>
				   <div class="layui-input-block">
					   <div class="circle-remind-fans-search">
						   <input type="text" name="tag" v-model="tag" autocomplete="off" placeholder="请输入标签" class="layui-input">
						   <input type="text" name="name" v-model="name" autocomplete="off" placeholder="粉丝昵称" class="layui-input">
						   <input type="text" name="start_time" autocomplete="off" placeholder="粉丝时间" class="layui-input" id="create_time" style="width: 290px;display: none;">
						   <button class="layui-btn layui-btn-normal" type="button" @click="getFans">搜索</button>
					   </div>
					   <div class="circle-remind-fans" id="fans-select"></div>
				   </div>
				 </div>
				 <div class="layui-form-item">
					<div class="layui-input-block">
					  <button class="layui-btn" lay-submit lay-filter="submitFans">确认</button>
					  <button type="reset" class="layui-btn layui-btn-primary">清空</button>
					</div>
				  </div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
	import {getFansByCustomIdAndTag} from '../../network/local/friend.js'
	
	export default{
		name:"CircleRemind",
		props:{
			customId:{
				type: Number,
				default: 0
			}
		},
		data(){
			return{
				tag: '',
				name: '',
				startTime: '',
				endTime: '',
				selectFans:[],
				transfer:null,
				from: null
			}
		},
		components:{
			
		},
		methods:{
			// 获取粉丝列表
			getFans(){
				let param = {
					tag: this.tag,
					name: this.name,
					startTime: this.startTime,
					endTime: this.endTime
				}
				// 加载粉丝数据后重新渲染列表
				getFansByCustomIdAndTag(this.customId,param,data=>{
					let fans = []
					if(data.length > 0){
						for (let i = 0; i < data.length; i++) {
							fans.push({
								"value": data[i].open_id,
								"title": data[i].wx_name,
								"disabled": "", 
								"checked": ""
							})
						}
						
					}
					//可以重载所有基础参数
					this.transfer.reload('fans-select', {
						data: fans,
						value: this.selectFans
					});
				})
			},
			
			//关闭页面
			close(){
				this.$emit("close-circle-remind")
			}
		},
		mounted() {
			// 使用layui渲染表单页面
			let _this = this
			let form,transfer,laydate
			layui.use(['form','transfer','laydate'], function(){
			  form = layui.form
			  transfer = layui.transfer
			  let laydate = layui.laydate
			  
			  //监听提交
			  form.on('submit(submitFans)', function(data){
				  _this.$emit('fans-remind-call',_this.selectFans)
			    return false;
			  })

			  // 穿梭树渲染
			  transfer.render({
				elem: '#fans-select'  ,//绑定元素
				title:['粉丝列表','已选粉丝列表'],
				showSearch:false,
				width:300,
				height: 400,
				data: [],
				value:[],
				id: 'fans-select' ,//定义索引
				onchange:function(data,index){
					 //如果数据来自左边，index 为 0，否则为 1
					if(index === 0){
						for (let i = 0; i < data.length; i++) {
							if(_this.selectFans.indexOf(data[i].value) === -1){
								_this.selectFans.push(data[i].value)
							}
						}
					}else if(index === 1){
						for (let i = 0; i < data.length; i++) {
							let fansIndex = _this.selectFans.indexOf(data[i].value)
							if(fansIndex !== -1){
								_this.selectFans.splice(fansIndex,1)
							}
						}
					}
				}
			  })
			  
			  // 时间选择器-开始时间
			  laydate.render({
				 elem: '#create_time' ,//指定元素
				 type: 'datetime',
				 range: true,
				 done:function(value,date,endDate){
					if(value === undefined || value === ''){
						_this.startTime = ''
						_this.endTime = ''
					}else{
						let dateArr = value.split(' - ')
						if(dateArr.length === 2){
							_this.startTime = dateArr[0]
							_this.endTime = dateArr[1]
						}
					}
				 }
			  })
			  
			  _this.transfer = transfer
			  _this.from = form
			  _this.from.render()
			  _this.getFans()
			});
		},
	}
</script>

<style>
	.circle-remind{
		position: relative;
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
		box-sizing: border-box;
		max-width: 1300px;
		margin: 0 auto;
	}
	.circle-remind-wrap{
		position: relative;
		width: 100%;
		height: 100%;
	}
	.circle-remind-wrap .circle-remind-header{
		height: 44px;
		line-height: 44px;
		border-bottom: 1px solid #eaeaea;
		padding: 0 20px;
		display: flex;
		justify-content: space-between;
		background-color: #eeeeee;
	}
	.circle-remind-header .circle-remind-h-opts span{
		cursor: pointer;
		display: inline-block;
		height: 34px;
		line-height: 34px;
		padding: 5px;
		user-select: none;
	}
	.circle-remind-box{
		padding: 10px 20px;
	}
	.circle-remind-fans-search{
		margin-bottom: 5px;
	}
	.circle-remind-fans-search > *{
		display: inline-block;
		vertical-align: middle;
	}
	.circle-remind-fans-search > input{
		margin-right: 5px;
	}
	.circle-remind-fans-page{
		margin-top: 5px;
	}
	.circle-remind-fans-page>.comp-page{
		justify-content: flex-start;
	}
	.layui-input{
		width: 148px;
	} 
	.layui-input:focus{
		border: 1px solid #42B983 !important;
	}
	.layui-form-label i{
		margin-right: 5px;
	}
</style>
